
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function TenisElbow(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Tenis elbow(lateral epicondylitis)"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Tennis elbow is a painful condition that occurs when tendons in your
                                    elbow are overloaded, usually by repetitive motions of the wrist and
                                    arm. Despite its name, athletes aren't the only people who develop
                                    tennis elbow.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Tenis-elbow(lateral-epicondylitis)/1.png")} alt="Tenis-elbow(lateral-epicondylitis)" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>The pain associated with tennis elbow may radiate from the outside of your elbow into your
                                    forearm and wrist. Pain and weakness may make it difficult to:</p>
                                <p>Shake hands or grip an object</p>
                                <p>Turn a doorknob</p>
                                <p>Hold a coffee cup</p>

                                <a className="links" href="https://en.wikipedia.org/wiki/Tennis_elbows">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default TenisElbow;